import React from "react";
import {ThemeProvider} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {Link as RouterLink} from "react-router-dom";
import Button from "@material-ui/core/Button";
import Copyright from "../../components/Copyright";
import landingPageStyle from "./landingPageStyle";
import {theme} from '../Dashboard/theme';

let themeCustom = {
  ...theme,
};

export default () => {
  const classes = landingPageStyle();

  return (
    <ThemeProvider theme={themeCustom}>
      <CssBaseline/>
      <Container
        justify="spaceBetween"
        className={classes.root}
        style={{
          paddingTop: '84px',
          minHeight: "100vh",
          minWidth: "100vw",
          display: "flex",
          flexDirection: "column",
          backgroundImage: "linear-gradient(to right top, #006db3, #0075bc, #007ec6, #0086cf, #008fd9, #1197df, #1d9fe6, #27a7ec, #38b0f1, #47baf6, #55c3fa, #63ccff)"
        }}>
        <AppBar position="absolute" className={classes.secondaryBar}>
          <Toolbar className={classes.toolbar}>
            <Grid container alignItems="flex-start" spacing={1}>
              <Grid item xs>
                <Typography color="inherit" variant="h5" component="h4">
                  Mind Body and Energy Connections
                </Typography>
              </Grid>
              <Grid container direction="column" justify="flex-end" alignItems="flex-end">
                <Grid item alignItems="flex-end">
                  <Typography color="inherit" variant="caption" component="p">
                    ©Brandy Gillmore. Human Potential Revolution. This information cannot be copied or reused in any form.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}/>
        <Container className={classes.container} style={{flex: "1 0 auto"}}>
          <Grid container spacing={3}>
            {/* Recent MapView */}
            <Grid container justify="center">
              <Paper
                className={classes.paper}
                style={{
                  minHeight: '30px',
                  minWidth: "200px",
                  textAlign: 'center'
                  // backgroundColor: 'transparent',
                  // boxShadow: 'none',
                }}>
                <Grid item>
                  <Typography style={{color: 'grey'}} variant="h4" component="h6">
                    Mind Body App
                  </Typography>
                </Grid>
                <Container className={classes.root}>
                  <Grid container direction="column"
                        justify="center"
                        alignItems="center"
                        style={{minHeight: "15px"}}>

                    <Grid item>
                      <img src="images/android-chrome-192x192.png" alt="mbp "/>
                    </Grid>

                    <Grid container direction="row"
                          justify="center"
                          alignItems="center"
                          style={{minHeight: "15px"}}
                    >
                      <Grid item style={{marginTop: '25px'}}>
                        <RouterLink to="/login" className={classes.link} style={{margin: "25px"}}>
                          <Button label="Login"
                            // containerElement={<RouterLink to="/login"/>}
                            // linkButton={true}
                                  component="button"
                                  variant="contained"
                                  color="primary"
                                  size="large"
                                  className={classes.button}
                          >
                            Login
                          </Button>
                        </RouterLink>
                      </Grid>
                      <Grid item style={{marginTop: '25px'}}>
                        <RouterLink to="/signup" className={classes.link} style={{margin: "25px"}}>
                          <Button label="Signup"
                                  component="button"
                                  variant="contained"
                                  color="primary"
                                  size="large"
                                  className={classes.button}
                          >
                            Signup
                          </Button>
                        </RouterLink>
                      </Grid>
                    </Grid>
                  </Grid>
                </Container>
                <br/><br/>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <Copyright/>
      </Container>
    </ThemeProvider>
  );
};